import { render } from "./PzProyectos.vue?vue&type=template&id=c4756ae6"
import script from "./PzProyectos.vue?vue&type=script&lang=js"
export * from "./PzProyectos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__